import { GameEvent } from 'excalibur';
import { InputItem } from '../../yoga/components/input-item';
import { INPUT_DIRECTION } from '../enums';

export class InputEvent extends GameEvent<InputItem> {
	constructor(public direction: INPUT_DIRECTION) {
		super();
	}
}
